import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'

// 密钥对生成 http://web.chacuo.net/netrsakeypair

const token = "abcdefghijklmnopqrstuvwxyz";

const publicKey = "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJ9K+/F3ZMYLDfFsKPF4nnCKPu5jHrgsgOu2eivHKNQ7ZjKNqIfrkMrp+V4hYsVjcU+CfCxZtncyv0eNEolKRjcCAwEAAQ==";

// 密钥
export function getToken() {
    return 'Bearer ' + encryptData(token + getRandomInt(100000, 999999));
}

// 加密
export function encryptData(txt) {
    const encryptor = new JSEncrypt()
    encryptor.setPublicKey(publicKey) // 设置公钥
    return encryptor.encrypt(txt) // 对数据进行加密
}

// 生成一个范围在[min, max]之间的随机整数
export function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

